import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subpage-pedagogia-del-instituto-pikler',
  templateUrl: './subpage-pedagogia-del-instituto-pikler.component.html',
  styleUrls: ['./subpage-pedagogia-del-instituto-pikler.component.scss']
})
export class SubpagePedagogiaDelInstitutoPiklerComponent implements OnInit {

  constructor() { 
    window.scroll(0,0);
  }

  ngOnInit() {
  }

}
